const SHAREITT_ISRAEL_COMMUNITY_NAME = 'זרזיר';

export function formatCommunityName(defaultKey, name) {
  if (name === SHAREITT_ISRAEL_COMMUNITY_NAME) {
    return `${defaultKey}_ShareittIsrael`;
  } else {
    return defaultKey + '_' + name.split(' ').join('');
  }
}
